import React from 'react';
import {Link, useLocation} from 'react-router-dom';

// returns a Link, but preserves the query string (so guest id and UTM query string params are preserved)
export const InvitationLink = (props) => {
  const newProps = {
    ...props,
  };
  const location = useLocation();
  if (typeof newProps.to === 'string') newProps.to = {pathname: newProps.to};
  newProps.to.search = newProps.to.search || location.search;
  return <Link {...newProps} />;
};
